import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home as HomeIcon, Search } from "lucide-react";
import SEO from "@/components/SEO";

const NotFound = () => (
  <div data-testid="not-found-page" className="max-w-3xl mx-auto px-5 lg:px-10 py-24 lg:py-32 text-center">
    <SEO path="/404" title="Page Not Found" description="This page doesn't exist on PTT NZ." noindex />
    <div className="font-mono-tech text-sm tracking-widest text-[var(--ptt-muted)]">ERROR 404</div>
    <h1 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-tight">This page went out of coverage.</h1>
    <p className="mt-4 text-[var(--ptt-muted)] max-w-xl mx-auto leading-relaxed">
      The page you're looking for doesn't exist or has moved. Try heading back home, or jump straight to plans and pricing.
    </p>
    <div className="mt-8 flex flex-wrap justify-center gap-3">
      <Link to="/" data-testid="not-found-home-link" className="ptt-button px-5 py-3 text-sm font-bold inline-flex items-center gap-2"><HomeIcon size={14} />Back to Home</Link>
      <Link to="/plans" data-testid="not-found-plans-link" className="ghost-button px-5 py-3 text-sm font-semibold inline-flex items-center gap-2"><Search size={14} />See Plans <ArrowRight size={14} /></Link>
    </div>
  </div>
);

export default NotFound;
